export class MailTemplatePopConfig {
  public static EndPoint = {
    Email: {
      PacketListing: '/solution/packetization/packet',
      ValidateReferral1: '/ref/referral/',
      ValidateReferral2: '/validate',
      Mailattachments: '/solution/packetization/packet/mailattachments',
      GetAllEmailTemplateCategories: '/solution/emailtemplate/getAllEmailTemplateCategories',
      GetEmailTemplateList: '/solution/emailtemplate/category/',
      getReferralSuggestions: '/ref/referral/getReferralSuggestions/',
      mailattachmentsValidation: '/solution/packetization/packet/mailattachments/validate',
      emailtemplateList: '/solution/emailtemplate/channel/EMAIL'
    },
    pages: {
      getAllPages: '/platform/page-designer/page/organization/{orgid}/pageTypes',
      responseSuggestions: '/solution/formresponse/suggestions'
    }
  };
}
